import React from "react";
import "../Css/Python.css";

import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const PyIfElse = () => {
  const [loading, setLoading] = useState(false);
  let [color] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div className="container-fluid background_py">
              <div className="row">
                <Navbar />

                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/pyLogo.png"}
                      width="60%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div
              className="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">Python – If Else, Decision Making</h1>
                <hr style={{ color: "white" }}></hr>
                <div>
                  <p>
                    In this tutorial, we will learn about the conditional
                    statements for decision making in Python. In Python, to
                    check the condition, the if-else statement is used. The
                    if-else statement in Python, helps the interpreter to
                    execute the instructions based on the given condition.
                    Different forms of the if-else statement are given below.
                  </p>
                </div>
                <div className="col-md-4"></div>
                <div className="col-md-4">
                  <ul style={{ color: "white", marginLeft: "140px" }}>
                    <li>if</li>
                    <li>if-else</li>
                    <li>if-elif-else</li>
                    <li>nested if</li>
                  </ul>
                </div>
                <div className="col-md-4"></div>
                <h1 className="py_h1">The IF Condition</h1>
                <p>
                  The if statement will use only when you want to execute some
                  statements based on the condition (if the condition is True).
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Syntax</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     Syntax:
                     if Condition:
                         #statements to be executed
                         #if the condition is true
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">
                  Example 1: Python program, to implement the IF statement.
                </h1>
                <hr style={{ color: "white" }} />
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     
                     marks=int(input("Enter Your Marks"))
                     if marks < 60:
                        print("You need more practice")
 
                      print("Your Marks:",marks)
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">If-elif-else in Python</h1>
                <hr style={{ color: "white" }} />
                <div>
                  <p>
                    If-elif-else in Python is useful when you have more than two
                    conditions to test and want to execute different statements
                    based on different conditions.
                  </p>
                </div>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Syntax</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     Syntax:
                     if Condition:
                       # statements to be executed
                       # when the condition is true
                     else:
                       # statements to be executed
                       # when the condition is false
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>

                <div className="bg-primary mt-4">
                  <p>
                    Note-: It is allowed only one if, at the beginning, only one
                    else at the end but, more then one elif block can possible
                    within if-else if you have many conditions to test.
                  </p>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">
                  Example 2: Python program to check even or odd, using the
                  if-else statement.
                </h1>
                <hr style={{ color: "white" }} />
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     n=int(input("Enter a Number"))
                     if n%2==0:
                        print("Even")
                     else:
                        print("Odd")
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1 mt-4">Nested IF</h1>
                <hr style={{ color: "white" }} />
                <p>
                  Whenever we use if condition as a statement within if or else
                  block, then it is known as nested if.
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     a=int(input("Enter First number : "))
                     b=int(input("Enter Second number : "))
                     c=int(input("Enter Third number : "))
                     if a>b:
                        if a>c:
                            print("First Largest")
                        else:
                          print("Third Largest")
                     elif b>c:
                          print("Second Largest")
                     else:
                        print("Third Largest")
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <PyFooter />
          </>
        )}
      </div>
    </>
  );
};
